<template>
    <div class="main">





        <BasicDialog @close="closeClicked">
            <v-row no-gutters class="flex-column mx-sm-16 px-sm-16">


                <v-row no-gutters class="justify-center">
                    <v-col cols="12" style="position: relative;" class="d-flex justify-center">
                        <img :src="AppConfigs.staticImages.VERIFICATIONCOMPLETE">
                    </v-col>
                </v-row>





                <v-row no-gutters class="d-flex justify-center mt-4 flex-column align-center">

                    <span class="text-h5 font-weight-bold">Verification Complete</span>
                    <span class="text-body-2 mt-1" style="opacity: 0.8">Thank you for verifying your phone number</span>

                </v-row>





                <v-row no-gutters class="justify-center mt-5">
                    <v-btn rounded="pill" class="  button--primary text-h6 font-weight-medium pl-6 pr-6 py-6 d-flex" @click="closeClicked">
                        <template v-slot:prepend>


                            <v-icon>
                                <coin-big></coin-big>
                            </v-icon>


                        </template>


                        Done


                    </v-btn>
                </v-row>


            </v-row>
        </BasicDialog>
    </div>
</template>



<script>

import { inject } from "vue";
import CoinBig from '@/icons/CoinBig.vue';
import { AppConfigs } from "@/app.configs";
import BasicDialog from '@/components/Common/Basic-Dialog.vue';


export default {
    name: 'VerificationComplete',
    components: {
        CoinBig,
        BasicDialog,
    },
    setup (props, { emit}) {
        let openDialog = inject('openDialog');
        
        const closeClicked = () => {
            openDialog.value = false;
            emit("close");
        };

        return {
            AppConfigs,
            openDialog,
            closeClicked,
        }
    },
};
</script>